module.exports = __webpack_public_path__ + "components/flag/static/square/gg-8b408ebc0e4c7b776081a9ffa6cf06a6.svg";